import React, { useEffect, useMemo, useState } from 'react';
import { useLocaleContext } from '../../../../context/LocaleContext';
import { useInterval } from 'usehooks-ts';
import { getEpisodeStatus } from '../../../../helpers/schedule-helper';
import { EPISODE_STATUSES } from '../../../../constants/common';

import './style.scss';

const ScheduleEpisodeStatus = ({
    timeStart,
    timeStop,
    delay = 3000,
    isVisible = true,
    altStatuses = false,
    onStatusUpdate = null,
}) => {
    const $locale = useLocaleContext();
    const [currentStatus, setCurrentStatus] = useState(getEpisodeStatus({timeStart, timeStop}));

    useEffect(() => {
        if (typeof onStatusUpdate === 'function') {
            onStatusUpdate(currentStatus);
        }
    }, [currentStatus]);

    useInterval(() => {
        setCurrentStatus(getEpisodeStatus({timeStart, timeStop}));
    }, (isVisible && currentStatus !== EPISODE_STATUSES.record) ? delay : null);

    if (!isVisible) {
        return <div />;
    }

    return (
        <div className="schedule-card-status">
            <span className={`schedule-card-status__current schedule-card-status__current--${currentStatus}`}>
                <span>
                    {
                        !altStatuses
                            ? $locale.get(`episode.status.${currentStatus}`)
                            : $locale.get(`episode.status.alt.${currentStatus}`)
                    }
                </span>
            </span>
        </div>
    )
};

export default ScheduleEpisodeStatus;
